import { createFileRoute } from '@tanstack/react-router';

import { KnowledgeBasePackageDetails } from '@/features/knowledge-base/KnowledgeBasePackageDetails';

export const Route = createFileRoute('/_protected/t/$tenantId/knowledge-base/package/$packageId')({
  component: KnowledgeBasePackageDetailRoute,
  validateSearch: (search: Record<string, unknown>): { doc?: string } => ({
    doc: typeof search.doc === 'string' && search.doc ? search.doc : undefined,
  }),
});

function KnowledgeBasePackageDetailRoute() {
  const { packageId } = Route.useParams();

  return <KnowledgeBasePackageDetails key={packageId} packageId={packageId} />;
}
